import { useEffect, useState } from 'react';

import { Api } from '../../services/api';

import P from 'prop-types';
import { PerfilComponent } from './PerfilComponent';
import { CargasAtribuidas } from './CargasAtribuidas';
import { ChatComponent } from './ChatComponent';
import { AplicativoComponent } from './AplicativoComponent';

export const TokenCanvas = ({ options }) => {
  const { id } = options;
  const [token, setToken] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const [optionActive, setOptionActive] = useState({
    cargas: '',
    aplicativo: '',
    chat: '',
    perfil: 'active',
  });

  const searchToken = async () => {
    try {
      const obj = await Api.get(`/token/${id}`);

      setToken(obj.data);
    } catch (e) {
      setToken(null);
    }
  };

  useEffect(() => {
    if (options.id) {
      searchToken();
      setOptionActive({
        cargas: 'active',
        chat: '',
        perfil: '',
        aplicativo: '',
      });
    }
  }, [options]);

  const handleOption = (option) => {
    const result = {
      cargas: '',
      chat: '',
      perfil: '',
      aplicativo: '',
      [option]: 'active',
    };
    setOptionActive(result);
  };

  return (
    <div>
      {!token ? (
        <h2>Aguarde um momento...</h2>
      ) : (
        <>
          <div>
            <ul className="nav nav-tabs mb-3">
              {optionActive && (
                <>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${optionActive.cargas}`}
                      aria-current="page"
                      onClick={() => handleOption('cargas')}
                    >
                      Cargas
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${optionActive.chat}`}
                      aria-current="page"
                      onClick={() => handleOption('chat')}
                    >
                      Chat
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${optionActive.perfil}`}
                      aria-current="page"
                      onClick={() => handleOption('perfil')}
                    >
                      Perfil
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${optionActive.aplicativo}`}
                      aria-current="page"
                      onClick={() => handleOption('aplicativo')}
                    >
                      Aplicativo
                    </a>
                  </li>
                </>
              )}
            </ul>
            {optionActive.perfil == 'active' && <PerfilComponent id={token.id} />}
            {optionActive.cargas == 'active' && <CargasAtribuidas id={token.id} />}
            {optionActive.chat == 'active' && <ChatComponent />}
            {optionActive.aplicativo == 'active' && (
              <AplicativoComponent chave={token.id} transportadora={token.transportadora} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

TokenCanvas.propTypes = {
  options: P.shape({
    id: P.number,
  }),
};
